import { render, staticRenderFns } from "./OwnerAboutPage.vue?vue&type=template&id=513ea044"
import script from "./OwnerAboutPage.vue?vue&type=script&lang=js"
export * from "./OwnerAboutPage.vue?vue&type=script&lang=js"
import style0 from "./OwnerAboutPage.vue?vue&type=style&index=0&id=513ea044&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports